import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {NgForOf, NgIf} from '@angular/common';
import {Diskusia} from '../model/diskusia';
import {Subscription} from 'rxjs';
import {AppService} from '../app.service';
import {MatDialog} from '@angular/material/dialog';
import {PodporaDetailComponent} from '../podpora-detail/podpora-detail.component';

@Component({
  selector: 'app-podpora',
  standalone: true,
  imports: [
    MatExpansionModule,
    NgIf,
    NgForOf
  ],
  templateUrl: './podpora.component.html',
  styleUrl: './podpora.component.css'
})
export class PodporaComponent implements OnInit, OnDestroy
{
    data: Diskusia[];
    diskusiaData: Subscription;
    onDiskusiaClickSubscription: Subscription;
    show = false;

    constructor(
      private appService: AppService,
      private dialogService: MatDialog
    ) {
    }

    ngOnDestroy(): void {
        this.onDiskusiaClickSubscription.unsubscribe();
    }

    ngOnInit(): void {
      this.diskusiaData = this.appService.diskusiaData
        .subscribe((data: Diskusia[]) => {
          this.data = data;
        });
      this.onDiskusiaClickSubscription =
        this.appService.onDiskusiaClickSubject.subscribe(
          () => {
            this.show = !this.show;
          }
        );
    }

    diskusiaOpen(d: Diskusia) {
      const dialogRef =
        this.dialogService.open(
          PodporaDetailComponent, {
            maxHeight: '90vh',
            width: '800px',
            data: {
                diskusia: d,
                display: 'mobile'
            }
          }
        );
    }
}
